import { ICalendarPlusSettings } from './types';

export const normalizeSettings = (
	settings: Partial<ICalendarPlusSettings>,
	defaultSettings: ICalendarPlusSettings
): ICalendarPlusSettings => {
	const normalized = { ...defaultSettings, ...settings };

	normalized.styles = {
		light: { ...defaultSettings.styles.light, ...settings.styles?.light },
		dark: { ...defaultSettings.styles.dark, ...settings.styles?.dark },
	};

	return normalized;
};
